module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-18.d6ee53ed.png";